import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { filter } from 'rxjs';
import { NetworkService } from './core/services/network.service';
import { ToastsContainerComponent } from './shared/components/toasts-container/toasts-container.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastsContainerComponent],
  template: `
    <router-outlet></router-outlet>
    <app-toasts-container></app-toasts-container>
  `,
  styles: [
    `
      :host {
        display: block;
        height: 100vh;
      }
    `,
  ],
})
export class App {
  private readonly router = inject(Router);
  private readonly modalService = inject(NgbModal);
  readonly networkService = inject(NetworkService);

  constructor() {
    // Đóng tất cả modal khi có thay đổi route
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationStart),
        takeUntilDestroyed(),
      )
      .subscribe(() => {
        this.modalService.dismissAll();
      });
  }
}
